import React, {useState, useRef} from "react";
import Button from "react-bootstrap/Button";
import {useNavigate} from "react-router-dom";
import "./login.css";

export function Authenticated(props) {
    const navigate = useNavigate();
    const userName = props.userName;
    const [textareaValue, setTextareaValue] = useState('');
    const [selectedFile, setSelectedFile] = useState(null);
    const [isUploading, setIsUploading] = useState(false);
    const [dragActive, setDragActive] = useState(false);
    const [isPublic, setIsPublic] = useState(false);
    const fileInputRef = useRef(null);

    const handleFileSelect = (event) => {
        const file = event.target.files[0];
        setSelectedFile(file);
        localStorage.setItem("localfilename", file.name);
    };
    
    const handleFileDrop = (event) => {
        event.preventDefault();
        setDragActive(false);
        const files = event.dataTransfer.files;
        if (files.length > 0) {
            setSelectedFile(files[0]);
            localStorage.setItem("localfilename", files[0].name);
        }
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragActive(true);
    };

    const handleDragLeave = () => {
        setDragActive(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        
        if (!selectedFile && textareaValue.trim() === "") {
            alert("Please select a file or enter some text");
            return;
        }
        
        setIsUploading(true);
        
        const formData = new FormData();
        if (selectedFile) {
            formData.append('file', selectedFile);
        }
        formData.append('email', userName);
        formData.append('filenametext', localStorage.getItem("localfilename") || '');
        formData.append('textinput', textareaValue);
        formData.append('public', isPublic.toString());

        try {
            const response = await fetch('/api/upload', {
                method: 'POST',
                body: formData,
            });
            
            const data = await response.json();
            console.log(data);
            localStorage.setItem("email", data.username);
            localStorage.setItem("textinput", textareaValue);
            localStorage.setItem("fileNameHash", data.downloadLink);
            navigate("/generate");
        } catch (error) {
            console.error(error);
            alert("Upload failed. Please try again.");
        } finally {
            setIsUploading(false);
        }
    };

    const removeFile = () => {
        setSelectedFile(null);
        localStorage.removeItem("localfilename");
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    return (
        <div className="upload-container">
            <div className="upload-card">
                <div className="upload-header">
                    <h2 className="upload-title">// file transfer terminal</h2>
                    <p className="upload-subtitle">drop a file or paste text to generate a link</p>
                </div>

                <form onSubmit={handleSubmit} className="upload-form">
                    <div className="upload-sections">
                        {/* File Upload Section */}
                        <div className="upload-section">
                            <h3 className="section-title">
                                <span className="section-icon">&gt;</span>
                                FILE
                            </h3>

                            <div
                                className={`file-dropzone ${dragActive ? 'drag-active' : ''} ${selectedFile ? 'has-file' : ''}`}
                                onDrop={handleFileDrop}
                                onDragOver={handleDragOver}
                                onDragLeave={handleDragLeave}
                                onClick={() => fileInputRef.current.click()}
                            >
                                <input
                                    type="file"
                                    id="fileInput"
                                    name="file"
                                    ref={fileInputRef}
                                    onChange={handleFileSelect}
                                    className="file-input"
                                />

                                {!selectedFile ? (
                                    <div className="dropzone-content">
                                        <div className="dropzone-icon">[+]</div>
                                        <p className="dropzone-text">&gt; drop file here or click to browse_</p>
                                        <p className="dropzone-hint">all file types accepted</p>
                                    </div>
                                ) : (
                                    <div className="file-info">
                                        <div className="file-icon">[f]</div>
                                        <div className="file-details">
                                            <p className="file-name">{selectedFile.name}</p>
                                            <p className="file-size">{(selectedFile.size / 1024 / 1024).toFixed(2)} mb</p>
                                        </div>
                                        <button
                                            type="button"
                                            className="remove-file-btn"
                                            onClick={(e) => { e.stopPropagation(); removeFile(); }}
                                        >
                                            [x]
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Text Input Section */}
                        <div className="upload-section">
                            <h3 className="section-title">
                                <span className="section-icon">&gt;</span>
                                TEXT INPUT
                            </h3>

                            <div className="text-input-container">
                                <textarea
                                    name="textinput"
                                    className="text-input"
                                    id="text-area"
                                    placeholder="// optional text message..."
                                    value={textareaValue}
                                    onChange={(e) => setTextareaValue(e.target.value)}
                                    rows={6}
                                />
                                <div className="text-counter">
                                    {textareaValue.length} chars
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="upload-actions">
                        <Button
                            type="submit"
                            className="upload-button"
                            disabled={isUploading || (!selectedFile && textareaValue.trim() === "")}
                        >
                            {isUploading ? (
                                <><span className="spinner" /> uploading</>
                            ) : '[ UPLOAD & GENERATE ]'}
                        </Button>

                        <div className="privacy-inline">
                            <label className="privacy-toggle">
                                <div className="toggle-switch">
                                    <input
                                        type="checkbox"
                                        checked={isPublic}
                                        onChange={(e) => setIsPublic(e.target.checked)}
                                        className="toggle-input"
                                    />
                                    <span className="toggle-slider" />
                                </div>
                                <span className="toggle-label">
                                    {isPublic ? 'public' : 'private'}
                                </span>
                            </label>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}
